export {
  searchClient,
  customSearchClient,
  indexName,
  retailMediaIndexName,
} from './search-client';
export { insightsConfig } from './insights-config';
export { normalizeProduct } from './normalize-product';
export type { ProductProps } from './normalize-product';
